<template>
  <div id="detail-mode">
    <div class="open-platform-header">
      <h1>{{ lanInfo.dockingModeHeaders[id] }}</h1>
    </div>
    <div class="content-block content-width">
      <div class="content-item" :class="{cn: lanType == 'cn'}" v-for="(item,index) of lanInfo.dockingModeContent[id]">
        <img :src="require(`../../assets/images/openPlatform/detail-mode${Number(id) + 1}-${index + 1}.png`)">
        <p v-html="item"></p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "openPlatformDetailMode",
  props: ['id'],
  computed: {
    lanInfo() {
      return this.$store.getters.getLanInfo.openPlatform;
    },
    lanType() {
      return this.$store.getters.getLanType;
    }
  },
}
</script>

<style scoped lang="scss">
.content-width {
  width: 1200px;
  margin: 0 auto;
}

#detail-mode {
  background: #0e285a;
  height: 399px;

  .open-platform-header {
    text-align: center;
    padding-top: 40px;

    h1 {
      font-size: 32px;
      color: #FFFFFF;
      line-height: 45px;
      font-weight: 400;
    }
  }

  .content-block {
    display: flex;
    margin-top: 63px;

    .content-item {
      font-size: 14px;
      line-height: 26px;
      color: #fff;
      display: flex;
      flex-direction: column;
      align-items: center;
      flex: 1;
      text-align: center;
      padding: 0 40px;

      &.cn {
        padding: 0 80px;
      }

      img {
        width: 110px;
        height: 110px;
        margin-bottom: 32px;
      }
    }

    .link {
      width: 104px;
      height: 44px;
      background: #0176D9;
      font-size: 16px;
      color: #FFFFFF;
      position: absolute;
      right: 20px;
      bottom: 40px;
      cursor: pointer;
    }
  }
}
</style>